var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhenotypeData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8C1515;}\n\t.st1{fill:#F9C002;}\n\t.st2{fill:#2094E8;}\n\t.st3{fill:#56BF46;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.8,352h22.4c6.4,0,12.8-6.4,12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4,0-12.8,6.4-12.8,12.8 v230.4C384,345.6,390.4,352,396.8,352z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.8,352h22.4c6.4,0,12.8-6.4,12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4,0-12.8,6.4-12.8,12.8 v198.4C192,345.6,198.4,352,204.8,352z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.8,352h22.4c6.4,0,12.8-6.4,12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4,0-12.8,6.4-12.8,12.8 v134.4C288,345.6,294.4,352,300.8,352z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496,400H48V80c0-8.9-7.1-16-16-16H16C7.1,64,0,71.1,0,80v336c0,17.7,14.3,32,32,32h464c8.9,0,16-7.1,16-16v-16 C512,407.1,504.9,400,496,400z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.8,352h22.4c6.4,0,12.8-6.4,12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4,0-12.8,6.4-12.8,12.8 v70.4C96,345.6,102.4,352,108.8,352z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhenotypeData);
export default __webpack_public_path__ + "static/media/PhenotypeData.d9ffac60e932366526d93265df0cc911.svg";
export { ForwardRef as ReactComponent };